console.log('🎯 [WISHLIST] Script cargado');

// Suprimir errores específicos de Swym - INTERCEPTACIÓN COMPLETA
var originalConsoleError = console.error;

// Interceptar console.error
console.error = function () {
  var args = Array.prototype.slice.call(arguments);
  var message = '';
  var firstArg = args[0];

  // Obtener el mensaje del error
  if (typeof firstArg === 'string') {
    message = firstArg;
  } else if (firstArg && firstArg.message) {
    message = firstArg.message;
  } else if (firstArg && firstArg.toString) {
    message = firstArg.toString();
  } else {
    message = args.join(' ');
  }

  // Verificar stack trace
  var stack = '';
  if (firstArg && firstArg.stack) {
    stack = firstArg.stack;
  } else if (args[1] && typeof args[1] === 'string') {
    stack = args[1];
  }

  // Suprimir errores de Swym querySelector
  if (
    (message && message.includes('querySelector') && message.includes('is not a valid selector')) ||
    (stack && (stack.includes('swym-ext-shopify') || stack.includes('initializeActionButtons')))
  ) {
    return; // No mostrar el error
  }

  // Llamar al console.error original para otros errores
  originalConsoleError.apply(console, args);
};

// Interceptar errores globales (captura fase)
var errorHandler = function (event) {
  var message = event.message || '';
  var filename = event.filename || '';
  var error = event.error || {};
  var stack = error.stack || '';

  // Suprimir errores de querySelector de Swym
  if (
    (message.includes('querySelector') && message.includes('is not a valid selector')) ||
    filename.includes('swym') ||
    stack.includes('swym-ext-shopify') ||
    stack.includes('initializeActionButtons')
  ) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
};

window.addEventListener('error', errorHandler, true);

// Interceptar errores no capturados (promesas)
window.addEventListener('unhandledrejection', function (event) {
  if (event.reason) {
    var reason = event.reason;
    var message = reason.message || reason.toString() || '';
    var stack = reason.stack || '';

    if (message.includes('querySelector') || stack.includes('swym') || stack.includes('initializeActionButtons')) {
      event.preventDefault();
      return false;
    }
  }
});

// Esperar a que el documento esté completamente listo
function initWishlistPage() {
  console.log('🎯 [WISHLIST] Iniciando página de wishlist');

  var loadingEl = document.getElementById('wishlist-loading');
  var emptyEl = document.getElementById('wishlist-empty');
  var productsEl = document.getElementById('wishlist-products');

  console.log('🔍 [WISHLIST] Elementos DOM encontrados:', {
    loading: !!loadingEl,
    empty: !!emptyEl,
    products: !!productsEl,
  });

  var retryCount = 0;
  var maxRetries = 30;

  function checkSwym() {
    console.log('🔄 [WISHLIST] Verificando Swym - Intento', retryCount + 1);

    if (typeof window._swat !== 'undefined') {
      console.log('✅ [WISHLIST] Swym detectado!');
      console.log('🔍 [WISHLIST] Métodos disponibles:', Object.keys(window._swat));

      // Intentar método moderno
      if (window._swat.fetchUserLists && typeof window._swat.fetchUserLists === 'function') {
        console.log('✅ [WISHLIST] Usando API moderna');
        loadWishlistModern();
      }
      // Intentar método legacy
      else if (window._swat.fetch && typeof window._swat.fetch === 'function') {
        console.log('✅ [WISHLIST] Usando API legacy');
        loadWishlistLegacy();
      } else {
        console.error('❌ [WISHLIST] No se encontraron métodos de fetch');
        showEmpty();
      }
    } else {
      retryCount++;
      if (retryCount < maxRetries) {
        setTimeout(checkSwym, 500);
      } else {
        console.error('❌ [WISHLIST] Swym no disponible después de', maxRetries, 'intentos');
        showEmpty();
      }
    }
  }

  // Esperar 2 segundos antes de empezar a verificar Swym
  setTimeout(function () {
    checkSwym();
  }, 2000);
}

function showEmpty() {
  console.log('⚠️ [WISHLIST] Mostrando estado vacío');
  var loadingEl = document.getElementById('wishlist-loading');
  var emptyEl = document.getElementById('wishlist-empty');
  if (loadingEl) loadingEl.style.display = 'none';
  if (emptyEl) emptyEl.style.display = 'block';
}

async function loadWishlistModern() {
  console.log('🚀 [WISHLIST] Cargando wishlist con API moderna');

  var loadingEl = document.getElementById('wishlist-loading');
  var emptyEl = document.getElementById('wishlist-empty');
  var productsEl = document.getElementById('wishlist-products');

  try {
    console.log('📋 [WISHLIST] Paso 1: Obteniendo listas del usuario...');
    var lists = await window._swat.fetchUserLists();
    console.log('✅ [WISHLIST] Listas recibidas:', lists);

    if (!lists || !Array.isArray(lists) || lists.length === 0) {
      console.log('❌ [WISHLIST] No se encontraron listas');
      loadingEl.style.display = 'none';
      emptyEl.style.display = 'block';
      return;
    }

    // Buscar lista por defecto
    var defaultList = lists.find(function (list) {
      return list.default === true || list.isDefault === true || list.type === 'wishlist';
    });

    if (!defaultList && lists.length > 0) {
      defaultList = lists[0];
    }

    if (!defaultList || !defaultList.id) {
      console.log('❌ [WISHLIST] No se encontró lista válida');
      loadingEl.style.display = 'none';
      emptyEl.style.display = 'block';
      return;
    }

    console.log('✅ [WISHLIST] Usando lista ID:', defaultList.id);

    console.log('📋 [WISHLIST] Paso 2: Obteniendo contenidos de la lista...');
    var listContents = await window._swat.fetchListContents(defaultList.id);
    console.log('✅ [WISHLIST] Contenidos recibidos:', listContents);

    loadingEl.style.display = 'none';

    // Procesar items
    var items = [];
    if (Array.isArray(listContents)) {
      items = listContents;
    } else if (listContents && listContents.items && Array.isArray(listContents.items)) {
      items = listContents.items;
    } else if (listContents && listContents.data && Array.isArray(listContents.data)) {
      items = listContents.data;
    }

    if (!items || items.length === 0) {
      console.log('❌ [WISHLIST] No se encontraron productos');
      emptyEl.style.display = 'block';
      return;
    }

    console.log('✅ [WISHLIST] Procesando', items.length, 'productos');
    productsEl.style.display = 'grid'; // El grid de Shopify usa display: grid

    var productsLoaded = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      console.log('🔄 [WISHLIST] Procesando producto', i + 1, ':', item);

      var handle = null;
      var productUrl = item.productUrl || item.du || item.url || item.product_url;

      if (productUrl) {
        var urlMatch = productUrl.match(/\/products\/([^/?]+)/);
        if (urlMatch && urlMatch[1]) {
          handle = urlMatch[1].trim();
        }
      }

      if (handle) {
        console.log('✅ [WISHLIST] Renderizando producto con handle:', handle);
        await renderProduct(handle, item, productsEl);
        productsLoaded++;
      } else {
        console.warn('❌ [WISHLIST] No se pudo extraer handle del producto:', item);
      }
    }

    if (productsLoaded === 0) {
      setTimeout(function () {
        if (productsEl.children.length === 0) {
          emptyEl.style.display = 'block';
        }
      }, 1000);
    }
  } catch (error) {
    console.error('❌ [WISHLIST] Error:', error);
    if (window._swat && window._swat.fetch) {
      console.log('🔄 [WISHLIST] Intentando con API legacy...');
      loadWishlistLegacy();
    } else {
      loadingEl.style.display = 'none';
      emptyEl.style.display = 'block';
    }
  }
}

function loadWishlistLegacy() {
  console.log('🚀 [WISHLIST] Cargando wishlist con API legacy');

  var loadingEl = document.getElementById('wishlist-loading');
  var emptyEl = document.getElementById('wishlist-empty');
  var productsEl = document.getElementById('wishlist-products');

  try {
    window._swat.fetch(function (products) {
      console.log('✅ [WISHLIST] Productos recibidos (legacy):', products);

      loadingEl.style.display = 'none';

      var productsArray = products;

      if (products && typeof products === 'object' && !Array.isArray(products)) {
        for (var key in products) {
          if (Array.isArray(products[key])) {
            productsArray = products[key];
            break;
          }
        }
      }

      if (!productsArray || !Array.isArray(productsArray) || productsArray.length === 0) {
        emptyEl.style.display = 'block';
        return;
      }

      console.log('✅ [WISHLIST] Procesando', productsArray.length, 'productos');
      productsEl.style.display = 'grid'; // El grid de Shopify usa display: grid

      var productsLoaded = 0;

      productsArray.forEach(function (item, index) {
        var handle = null;

        if (item.du) {
          var urlMatch = item.du.match(/\/products\/([^/?]+)/);
          if (urlMatch && urlMatch[1]) {
            handle = urlMatch[1].trim();
          } else {
            var parts = item.du.split('/products/');
            if (parts.length > 1) {
              handle = parts[1].split('?')[0].split('#')[0].trim();
            }
          }
        }

        if (handle) {
          renderProduct(handle, item, productsEl);
          productsLoaded++;
        }
      });

      if (productsLoaded === 0 && productsArray.length > 0) {
        setTimeout(function () {
          if (productsEl.children.length === 0) {
            emptyEl.style.display = 'block';
          }
        }, 3000);
      }
    });
  } catch (error) {
    console.error('❌ [WISHLIST] Error (legacy):', error);
    loadingEl.style.display = 'none';
    emptyEl.style.display = 'block';
  }
}

async function renderProduct(handle, swymItem, container) {
  try {
    console.log('📥 [WISHLIST] Cargando producto:', handle);

    var response = await fetch('/products/' + handle + '.js');
    if (!response.ok) throw new Error('Producto no encontrado');

    var product = await response.json();
    console.log('✅ [WISHLIST] Producto cargado:', product.title);

    // Construir URL localizada con el prefijo del market activo (e.g. /en-int/, /ca/)
    // window.Shopify.routes.root contiene el prefijo correcto según el market/idioma activo
    function localizedUrl(url) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // root incluye trailing slash (e.g. '/en-int/'), url empieza con '/' (e.g. '/products/handle')
      return root.replace(/\/$/, '') + url;
    }

    // Crear contenedor para el card - usar estructura de rocket-card-product
    var cardWrapper = document.createElement('div');
    cardWrapper.className = 'wishlist-product-card';

    // Obtener metafields del producto
    // Nota: El API de Shopify /products/{handle}.js no incluye metafields por defecto
    // Se intentará obtenerlos, pero si no están disponibles se usarán valores por defecto
    var metafields = product.metafields || {};
    var rocketMetafields = {};
    var magentoMetafields = {};

    // Intentar obtener metafields de diferentes formas según la estructura del API
    if (metafields.rocket) {
      rocketMetafields = metafields.rocket;
    } else if (metafields['rocket.model']) {
      rocketMetafields = {
        model: metafields['rocket.model'],
        color: metafields['rocket.color'],
        gender: metafields['rocket.gender'],
      };
    }

    if (metafields.magento) {
      magentoMetafields = metafields.magento;
    } else if (metafields['magento.refe']) {
      magentoMetafields = {
        refe: { value: metafields['magento.refe'] },
        short_name: { value: metafields['magento.short_name'] },
      };
    }

    var productModel = (rocketMetafields.model && (rocketMetafields.model.value || rocketMetafields.model)) || '';
    var productColor = (rocketMetafields.color && (rocketMetafields.color.value || rocketMetafields.color)) || '';
    var productRefe = (magentoMetafields.refe && (magentoMetafields.refe.value || magentoMetafields.refe)) || '';
    var productShortName =
      (magentoMetafields.short_name && (magentoMetafields.short_name.value || magentoMetafields.short_name)) ||
      product.title;

    // Obtener imagen destacada del producto
    var featuredImage = product.featured_image || (product.images && product.images[0]) || '';
    var imageUrl = featuredImage;

    // Generar srcset correctamente
    var srcset = '';
    var baseImageUrl = '';
    if (imageUrl) {
      var urlParts = imageUrl.split('?');
      baseImageUrl = urlParts[0];
      srcset =
        baseImageUrl + '?width=720 720w, ' + baseImageUrl + '?width=1066 1066w, ' + baseImageUrl + '?width=1500 1500w';
    }

    // Obtener precio
    var price = product.price;
    var comparePrice = product.compare_at_price;
    var isOnSale = comparePrice && comparePrice > price;
    var firstVariant = product.variants && product.variants[0];
    var variants = product.variants || [];
    var hasMultipleVariants = variants.length > 1;

    // Crear badge HTML
    var badgeHTML = '';
    var productTags = (product.tags || []).map(function (tag) {
      return tag.toLowerCase();
    });
    if (productTags.indexOf('new') !== -1) {
      badgeHTML += '<span class="badge badge--bottom-left new">Nuevo</span>';
    }
    if (!product.available) {
      badgeHTML += '<span class="badge badge--bottom-left out-stock">Agotado</span>';
    } else if (isOnSale) {
      badgeHTML += '<span class="badge badge--bottom-left sale">Oferta</span>';
    }

    // Crear precio HTML - usando la estructura exacta del HTML de referencia
    var priceHTML = '';
    if (isOnSale) {
      priceHTML =
        '<div class="price__regular">' +
        '<span class="visually-hidden visually-hidden--inline">Precio habitual</span>' +
        '<span class="price-item price-item--regular">' +
        formatMoney(price) +
        '</span>' +
        '</div>' +
        '<div class="price__sale">' +
        '<span class="visually-hidden visually-hidden--inline">Precio habitual</span>' +
        '<span><s class="price-item price-item--regular">' +
        formatMoney(comparePrice) +
        '</s></span>' +
        '<span class="visually-hidden visually-hidden--inline">Precio de oferta</span>' +
        '<span class="price-item price-item--sale price-item--last">' +
        formatMoney(price) +
        '</span>' +
        '</div>';
    } else {
      priceHTML =
        '<div class="price__regular">' +
        '<span class="visually-hidden visually-hidden--inline">Precio habitual</span>' +
        '<span class="price-item price-item--regular">' +
        formatMoney(price) +
        '</span>' +
        '</div>' +
        '<div class="price__sale">' +
        '<span class="visually-hidden visually-hidden--inline">Precio habitual</span>' +
        '<span><s class="price-item price-item--regular">' +
        formatMoney(price) +
        '</s></span>' +
        '<span class="visually-hidden visually-hidden--inline">Precio de oferta</span>' +
        '<span class="price-item price-item--sale price-item--last">' +
        formatMoney(price) +
        '</span>' +
        '</div>';
    }

    // Generar variantes para el slider
    var variantSliderHTML = '';
    if (hasMultipleVariants) {
      variants.forEach(function (variant, index) {
        var variantAvailable = variant.available !== false;
        // Agregar estilos inline para que el swiper-slide y el botón tengan el ancho correcto
        variantSliderHTML +=
          '<div class="swiper-slide" style="width: fit-content; margin-right: 20px;">' +
          '<product-form class="product-form">' +
          '<form id="' +
          variant.id +
          '" class="form" novalidate="novalidate" data-type="add-to-cart-form" style="margin-top: 0 !important;">' +
          '<modal-opener data-variant="' +
          variant.id +
          '" data-product="' +
          product.id +
          '" data-section-id="wishlist" data-modal="#QuickAdd-' +
          variant.id +
          '">' +
          '<button id="ProductSubmitButton-' +
          variant.id +
          '" type="submit" name="add" class="product-form__submit variant-options-card' +
          (index === 0 && variant.inventory_quantity > 0 ? ' active' : '') +
          (!variantAvailable ? ' notActive' : '') +
          '" aria-haspopup="dialog" aria-live="polite" style="width: 25px !important; min-width: auto !important; max-width: fit-content !important; padding: 0 !important; white-space: nowrap !important;"' +
          (!variantAvailable ? ' aria-disabled="true"' : '') +
          '>' +
          '<input type="hidden" name="id" value="' +
          variant.id +
          '">' +
          '<span class="product-form__submit__title' +
          (!variantAvailable ? ' notActive' : '') +
          '" style="padding: 0 !important; margin: 0 !important; display: inline-block !important;">' +
          (variant.title || variant.option1 || '') +
          '</span>' +
          '</button>' +
          '</modal-opener>' +
          '</form>' +
          '</product-form>' +
          '</div>';
      });
    }

    // Crear el HTML del card usando la estructura de rocket-card-product
    // Según el HTML de referencia, usa "square" no "custom" para data-media_aspect_ratio
    var cardHTML =
      '<card-product class="rocket-card-container" data-media_aspect_ratio="square" data-product-name="' +
      (productShortName || product.title) +
      '">' +
      '<div class="card-wrapper rocket-card-wrapper product-card-wrapper underline-links-hover">';

    // Botón de wishlist - usando los mismos SVGs que rocket-card-product.liquid
    // En la página de wishlist, todos los productos ya están en la wishlist,
    // así que agregamos la clase swym-added y cambiamos la acción a deleteFromWishlist
    if (window.customer) {
      cardHTML +=
        '<button type="button" aria-label="Remove from Wishlist" data-with-epi="true" ' +
        'class="swym-button swym-add-to-wishlist-view-product swym-added product_' +
        product.id +
        '" ' +
        'data-swaction="deleteFromWishlist" ' +
        'data-product-id="' +
        product.id +
        '" ' +
        'data-variant-id="' +
        (firstVariant ? firstVariant.id : '') +
        '" ' +
        'data-product-url="' +
        window.location.origin +
        localizedUrl(product.url) +
        '">' +
        '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M8.49702 13.8032L14.741 7.49915C15.5512 6.67224 16.0035 5.55981 16.0003 4.40217C15.9972 3.24453 15.5387 2.1346 14.724 1.31215C14.3244 0.904478 13.8476 0.580347 13.3215 0.358614C12.7955 0.136882 12.2306 0.0219755 11.6597 0.0205797C11.0888 0.0191839 10.5233 0.131326 9.99613 0.350484C9.46898 0.569641 8.99066 0.891437 8.58902 1.29715L7.99302 1.90015L7.38802 1.29015C6.98891 0.883017 6.51283 0.559296 5.98748 0.337812C5.46213 0.116328 4.89799 0.00150349 4.32786 1.46663e-05C3.75774 -0.00147416 3.193 0.110403 2.6665 0.32914C2.14 0.547876 1.66225 0.869108 1.26102 1.27415C-0.426984 2.97915 -0.418984 5.75015 1.27702 7.46315L7.55402 13.8032C7.81402 14.0662 8.23702 14.0662 8.49702 13.8032ZM9.30002 2.00015C9.60873 1.68853 9.97637 1.44146 10.3815 1.27334C10.7867 1.10521 11.2212 1.01939 11.6599 1.02088C12.0985 1.02237 12.5325 1.11114 12.9365 1.28201C13.3405 1.45288 13.7064 1.70244 14.013 2.01615C14.6422 2.65149 14.9966 3.50869 14.9995 4.40288C15.0025 5.29707 14.654 6.15661 14.029 6.79615V6.79815L8.02502 12.8582L1.98702 6.75915C0.674016 5.43315 0.673016 3.28915 1.97202 1.97715C2.28033 1.66611 2.64745 1.4195 3.05199 1.2517C3.45653 1.0839 3.89041 0.998246 4.32837 0.999735C4.76632 1.00122 5.19961 1.08982 5.603 1.26037C6.00639 1.43092 6.37182 1.68002 6.67802 1.99315L7.63802 2.96315C7.68451 3.01017 7.73988 3.04749 7.8009 3.07297C7.86192 3.09844 7.92739 3.11156 7.99352 3.11156C8.05964 3.11156 8.12511 3.09844 8.18613 3.07297C8.24715 3.04749 8.30252 3.01017 8.34902 2.96315L9.30002 2.00015Z" fill="#4C4744"/>' +
        '</svg>' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-wishlist-added">' +
        '<path d="M10.497 16.8032L16.741 10.4992C17.5512 9.67224 18.0035 8.55981 18.0003 7.40217C17.9972 6.24453 17.5387 5.1346 16.724 4.31215C16.3244 3.90448 15.8476 3.58035 15.3215 3.35861C14.7955 3.13688 14.2306 3.02198 13.6597 3.02058C13.0888 3.01918 12.5233 3.13133 11.9961 3.35048C11.469 3.56964 10.9907 3.89144 10.589 4.29715L9.99302 4.90015L9.38802 4.29015C8.98891 3.88302 8.51283 3.5593 7.98748 3.33781C7.46213 3.11633 6.89799 3.0015 6.32786 3.00001C5.75774 2.99853 5.193 3.1104 4.6665 3.32914C4.14 3.54788 3.66225 3.86911 3.26102 4.27415C1.57302 5.97915 1.58102 8.75015 3.27702 10.4632L9.55402 16.8032C9.81402 17.0662 10.237 17.0662 10.497 16.8032ZM11.3 5.00015C11.6087 4.68853 11.9764 4.44146 12.3815 4.27334C12.7867 4.10521 13.2212 4.01939 13.6599 4.02088C14.0985 4.02237 14.5325 4.11114 14.9365 4.28201C15.3405 4.45288 15.7064 4.70244 16.013 5.01615C16.6422 5.65149 16.9966 6.50869 16.9995 7.40288C17.0025 8.29707 16.654 9.15661 16.029 9.79615V9.79815L10.025 15.8582L3.98702 9.75915C2.67402 8.43315 2.67302 6.28915 3.97202 4.97715C4.28033 4.66611 4.64745 4.4195 5.05199 4.2517C5.45653 4.0839 5.89041 3.99825 6.32837 3.99974C6.76632 4.00122 7.19961 4.08982 7.603 4.26037C8.00639 4.43092 8.37182 4.68002 8.67802 4.99315L9.63802 5.96315C9.68451 6.01017 9.73988 6.04749 9.8009 6.07297C9.86192 6.09844 9.92739 6.11156 9.99352 6.11156C10.0596 6.11156 10.1251 6.09844 10.1861 6.07297C10.2472 6.04749 10.3025 6.01017 10.349 5.96315L11.3 5.00015Z" fill="#4C4744"/>' +
        '<path d="M3.5 9.5L10 16L17 9V6.5L16 4.5L14 4L11.5 4.5L10 6L8.5 4.5L6 4L4 4.5L3 7L3.5 9.5Z" fill="#4C4744" stroke="#4C4744"/>' +
        '</svg>' +
        '</button>';
    } else {
      cardHTML +=
        '<a class="swym-button swym-add-to-wishlist-view-product swym-loaded" href="' +
        (window.routes && window.routes.account_url ? window.routes.account_url : '/account') +
        '">' +
        '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M8.49702 13.8032L14.741 7.49915C15.5512 6.67224 16.0035 5.55981 16.0003 4.40217C15.9972 3.24453 15.5387 2.1346 14.724 1.31215C14.3244 0.904478 13.8476 0.580347 13.3215 0.358614C12.7955 0.136882 12.2306 0.0219755 11.6597 0.0205797C11.0888 0.0191839 10.5233 0.131326 9.99613 0.350484C9.46898 0.569641 8.99066 0.891437 8.58902 1.29715L7.99302 1.90015L7.38802 1.29015C6.98891 0.883017 6.51283 0.559296 5.98748 0.337812C5.46213 0.116328 4.89799 0.00150349 4.32786 1.46663e-05C3.75774 -0.00147416 3.193 0.110403 2.6665 0.32914C2.14 0.547876 1.66225 0.869108 1.26102 1.27415C-0.426984 2.97915 -0.418984 5.75015 1.27702 7.46315L7.55402 13.8032C7.81402 14.0662 8.23702 14.0662 8.49702 13.8032ZM9.30002 2.00015C9.60873 1.68853 9.97637 1.44146 10.3815 1.27334C10.7867 1.10521 11.2212 1.01939 11.6599 1.02088C12.0985 1.02237 12.5325 1.11114 12.9365 1.28201C13.3405 1.45288 13.7064 1.70244 14.013 2.01615C14.6422 2.65149 14.9966 3.50869 14.9995 4.40288C15.0025 5.29707 14.654 6.15661 14.029 6.79615V6.79815L8.02502 12.8582L1.98702 6.75915C0.674016 5.43315 0.673016 3.28915 1.97202 1.97715C2.28033 1.66611 2.64745 1.4195 3.05199 1.2517C3.45653 1.0839 3.89041 0.998246 4.32837 0.999735C4.76632 1.00122 5.19961 1.08982 5.603 1.26037C6.00639 1.43092 6.37182 1.68002 6.67802 1.99315L7.63802 2.96315C7.68451 3.01017 7.73988 3.04749 7.8009 3.07297C7.86192 3.09844 7.92739 3.11156 7.99352 3.11156C8.05964 3.11156 8.12511 3.09844 8.18613 3.07297C8.24715 3.04749 8.30252 3.01017 8.34902 2.96315L9.30002 2.00015Z" fill="#4C4744"/>' +
        '</svg>' +
        '</a>';
    }

    // Card principal - usando las mismas clases que rocket-card-product
    // Según el HTML de referencia, usa card--card con color-accent-1 gradient
    // El card__inner solo tiene ratio cuando es card--card (no color scheme)
    cardHTML +=
      '<div class="card rocket-card card--card card--media color-accent-1 gradient ratio" style="--ratio-percent: 100%;">' +
      '<div class="card__inner ratio" style="--ratio-percent: 100%;">';

    // Imagen del producto
    if (imageUrl && baseImageUrl) {
      cardHTML +=
        '<a href="' +
        localizedUrl(product.url) +
        '" class="card__inner--link-product">' +
        '<div class="card__media">' +
        '<div class="media media--transparent media--hover-effect">' +
        '<img srcset="' +
        srcset +
        '" ' +
        'src="' +
        baseImageUrl +
        '?width=1500" ' +
        'sizes="(min-width: 1400px) 360px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" ' +
        'alt="' +
        (product.title || 'Producto') +
        '" ' +
        'class="motion-reduce" loading="lazy">' +
        '</div>' +
        '</div>' +
        '</a>';
    }

    // Contenido del card (dentro del card__inner)
    // Necesita data-type-product y data-size-guide según el HTML de referencia
    cardHTML +=
      '<div class="card__content" data-section-id="wishlist" data-product-id="' +
      product.id +
      '" data-product-available="' +
      product.available +
      '" data-type-product="" data-size-guide="false">' +
      '<div class="card__information">' +
      '<div class="card__information--title-price' +
      (isOnSale ? ' price--on-sale' : '') +
      '">';

    // Referencia
    if (productRefe) {
      cardHTML += '<a href="' + localizedUrl(product.url) + '" class="card__heading__subtitle">' + productRefe + '</a>';
    }

    // Precio - usando la estructura del HTML de referencia
    cardHTML +=
      '<div class="card-information__price">' +
      '<div class="price' +
      (isOnSale ? ' price--on-sale' : '') +
      (!product.available ? ' price--sold-out' : '') +
      '">' +
      '<div class="price__container" data-price="' +
      price +
      '">' +
      priceHTML +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';

    // Dentro del card__inner solo mostramos la referencia en el subtitle
    // El título completo va en el card__content fuera del card
    // Mostrar el título completo del producto aquí también para que sea visible
    if (product.title) {
      cardHTML +=
        '<span class="card__heading__subtitle" style="width: 100% !important; max-width: 100% !important; overflow: visible !important; text-overflow: clip !important; white-space: normal !important; display: block !important;">' +
        product.title +
        '</span>';
    }

    cardHTML += '</div>'; // Cierre card__information

    // Badges - según el HTML de referencia usa "top left" no solo "badge--bottom-left"
    if (badgeHTML) {
      cardHTML += '<div class="card__badge top left">' + badgeHTML + '</div>';
    }

    // Quick add con variantes
    if (hasMultipleVariants) {
      cardHTML +=
        '<card-quick-add>' +
        '<div class="card__layout-quickadd">' +
        (!product.available ? '<div class="card__layout-outstock__heading">Agotado</div>' : '') +
        '<span class="card__layout-quickadd__heading">' +
        (product.available ? 'Seleccionar talla' : 'Notificar disponibilidad') +
        '</h4>' +
        '<div class="card__layout-quickadd__variants" style="max-height:35px!important;">' +
        '<div class="swiper">' +
        '<div class="swiper-wrapper">' +
        variantSliderHTML +
        '</div>' +
        '</div>' +
        '<div class="card__layout-quickadd__variants--arrows">' +
        '<div class="swiper-navigation swiper-button-prev">' +
        '<svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M5 11L1 7L5 3" stroke="#2C2A29"/>' +
        '</svg>' +
        '</div>' +
        '<div class="swiper-navigation swiper-button-next">' +
        '<svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 11L5 7L1 3" stroke="#2C2A29"/>' +
        '</svg>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="card__layout-quickadd-overlay"></div>' +
        '</card-quick-add>' +
        '<card-open-quickadd class="medium-hide large-up-hide">' +
        '<button class="card__open-quickadd">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7 0V14" stroke="#4C4744"/>' +
        '<path d="M0 7L14 7" stroke="#4C4744"/>' +
        '</svg>' +
        '</button>' +
        '</card-open-quickadd>';
    } else if (firstVariant) {
      // Una sola variante
      cardHTML +=
        '<card-quick-add>' +
        '<div class="card__layout-quickadd one-variant">' +
        '<product-form class="product-form">' +
        '<form id="' +
        firstVariant.id +
        '" class="form" novalidate="novalidate" data-type="add-to-cart-form" style="margin-top: 0 !important;">' +
        '<modal-opener data-modal="#QuickAdd-' +
        firstVariant.id +
        '" data-variant="' +
        firstVariant.id +
        '" data-product="' +
        product.id +
        '" data-section-id="wishlist">' +
        '<button id="ProductSubmitButton-' +
        firstVariant.id +
        '" type="submit" name="add" class="product-form__submit variant-options-card' +
        (!firstVariant.available ? ' notActive' : '') +
        '" aria-haspopup="dialog" aria-live="polite"' +
        (!firstVariant.available ? ' aria-disabled="true"' : '') +
        '>' +
        '<input type="hidden" name="id" value="' +
        firstVariant.id +
        '">' +
        '<span class="product-form__submit__title' +
        (!firstVariant.available ? ' notActive' : '') +
        '">Añadir al carrito</span>' +
        '</button>' +
        '</modal-opener>' +
        '</form>' +
        '</product-form>' +
        '</div>' +
        '<div class="card__layout-quickadd-overlay"></div>' +
        '</card-quick-add>';
    }

    cardHTML += '</div>'; // Cierre card__content
    cardHTML += '</div>'; // Cierre card__inner
    cardHTML += '</div>'; // Cierre card

    // Información adicional fuera del card pero dentro del card-wrapper
    cardHTML +=
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<div class="card__information__title">' +
      '<div class="card__information--title-price' +
      (isOnSale ? ' price--on-sale' : '') +
      '">';
    var productTitle = product.title.split(' | ');

    if (productTitle[1]) {
      cardHTML += '<a href="' + localizedUrl(product.url) + '" class="card__heading__subtitle">' + productTitle[1] + '</a>';
    }

    cardHTML +=
      '<div class="card-information__price">' +
      '<div class="price' +
      (isOnSale ? ' price--on-sale' : '') +
      (!product.available ? ' price--sold-out' : '') +
      '">' +
      '<div class="price__container" data-price="' +
      price +
      '">' +
      priceHTML +
      '<small class="unit-price caption hidden">' +
      '<span class="visually-hidden">Precio unitario</span>' +
      '<span class="price-item price-item--last">' +
      '<span></span>' +
      '<span aria-hidden="true">/</span>' +
      '<span class="visually-hidden">&nbsp;por&nbsp;</span>' +
      '<span></span>' +
      '</span>' +
      '</small>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';

    // Título del producto completo - debe mostrarse sin recortar
    // Usar product.title completo y agregar estilo para evitar recorte
    var productTitle = product.title || productShortName || '';
    cardHTML +=
      '<h3 class="card__heading h5" id="title-wishlist-' +
      product.id +
      '">' +
      '<a href="' +
      localizedUrl(product.url) +
      '" id="CardLink-wishlist-' +
      product.id +
      '" class="full-unstyled-link" aria-labelledby="CardLink-wishlist-' +
      product.id +
      ' Badge-wishlist-' +
      product.id +
      '">' +
      '</a>' +
      '<span class="card__heading__subtitle" style="width: 100% !important; max-width: 100% !important; overflow: visible !important; text-overflow: clip !important; white-space: normal !important; display: block !important;">' +
      productTitle +
      '</span>' +
      '</h3>';

    cardHTML += '</div></div></div>'; // Cierres card__information__title, card__information, card__content
    cardHTML += '</div>'; // Cierre card-wrapper
    cardHTML += '</card-product>'; // Cierre card-product

    cardWrapper.innerHTML = cardHTML;

    // Agregar script JSON con los datos del producto para que funcionen los custom elements
    var scriptTag = document.createElement('script');
    scriptTag.type = 'application/json';
    scriptTag.textContent = JSON.stringify(product);
    cardWrapper.appendChild(scriptTag);

    // Agregar al contenedor
    try {
      container.appendChild(cardWrapper);
    } catch (appendError) {
      try {
        if (cardWrapper && container) {
          container.insertBefore(cardWrapper, null);
        }
      } catch (e) {
        // Silenciar error
      }
    }
  } catch (error) {
    var errorMsg = error && error.message ? error.message : String(error);
    var errorStack = error && error.stack ? error.stack : '';
    var errorName = error && error.name ? error.name : '';
    var errorString = String(error);

    var isSwymError =
      errorMsg.includes('querySelector') ||
      errorMsg.includes('is not a valid selector') ||
      errorString.includes('querySelector') ||
      errorString.includes('is not a valid selector') ||
      errorStack.includes('swym-ext-shopify') ||
      errorStack.includes('swym') ||
      errorStack.includes('Swym') ||
      errorStack.includes('initializeActionButtons') ||
      errorName === 'SwymError' ||
      errorName === 'SyntaxError';

    if (isSwymError) {
      try {
        if (cardWrapper && container && cardWrapper.parentNode !== container) {
          container.appendChild(cardWrapper);
        }
      } catch (e) {
        // Silenciar error
      }
      return;
    } else {
      console.error('❌ [WISHLIST] Error renderizando producto:', handle, error);
    }
  }
}

function formatMoney(cents) {
  var value = (cents / 100).toFixed(2).replace('.', ',');
  return value + ' €';
}

// CSS adicional
var style = document.createElement('style');
style.textContent =
  '.wishlist-loading-card { display: flex; align-items: center; justify-content: center; min-height: 400px; } ' +
  '.spinner-small { border: 2px solid #f3f3f3; border-top: 2px solid #000; border-radius: 50%; width: 30px; height: 30px; animation: spin 1s linear infinite; } ' +
  '.wishlist-product-card .rocket-card-wrapper { position: relative !important; } ' +
  '.wishlist-product-card .swym-button.swym-add-to-wishlist-view-product { display: flex !important; opacity: 1 !important; cursor: pointer; background: transparent !important; border: none !important; padding: 0 !important; position: absolute !important; top: 12px !important; right: 12px !important; z-index: 2 !important; width: 20px !important; height: 20px !important; justify-content: center !important; align-items: center !important; } ' +
  '.wishlist-product-card .swym-button.swym-add-to-wishlist-view-product.swym-added svg:not(.icon-wishlist-added) { display: none !important; } ' +
  '.wishlist-product-card .swym-button.swym-add-to-wishlist-view-product.swym-added svg.icon-wishlist-added { display: block !important; width: 25px !important; height: 20px !important; } ' +
  '.wishlist-product-card .swym-button.swym-add-to-wishlist-view-product:not(.swym-added) svg.icon-wishlist-added { display: none !important; } ' +
  '.wishlist-product-card .swym-button.swym-add-to-wishlist-view-product svg { pointer-events: none; }';
document.head.appendChild(style);

// Función para manejar la eliminación de productos del wishlist
function handleWishlistRemoval() {
  // Escuchar eventos de click en los botones de wishlist
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.swym-button.swym-added[data-swaction="deleteFromWishlist"]');
    if (button) {
      // Prevenir cualquier comportamiento por defecto
      event.preventDefault();
      event.stopPropagation();

      // Remover el producto de la vista después de un breve delay para que Swym procese
      var productCard = button.closest('.wishlist-product-card');
      if (productCard) {
        // Esperar un momento para que Swym procese la eliminación
        setTimeout(function () {
          productCard.style.transition = 'opacity 0.3s ease';
          productCard.style.opacity = '0';
          setTimeout(function () {
            productCard.remove();

            // Verificar si la lista está vacía
            var productsEl = document.getElementById('wishlist-products');
            var emptyEl = document.getElementById('wishlist-empty');
            if (productsEl && productsEl.children.length === 0) {
              if (emptyEl) {
                emptyEl.style.display = 'block';
              }
              if (productsEl) {
                productsEl.style.display = 'none';
              }
            }
          }, 300);
        }, 200);
      }
    }
  });

  // Escuchar eventos de Swym cuando se elimina un producto
  if (window.SwymCallbacks) {
    window.SwymCallbacks.product_removed_from_wishlist = function (product) {
      console.log('✅ [WISHLIST] Producto eliminado de wishlist:', product);
      // El producto ya debería estar removido por el listener de click
    };
  }
}

// Iniciar cuando el documento esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initWishlistPage();
    handleWishlistRemoval();
  });
} else {
  initWishlistPage();
  handleWishlistRemoval();
}
